module.exports = __webpack_public_path__ + "static/media/Picture51.eb4edf7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture51.png
// module id = 1550
// module chunks = 0